import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
//-----------private route to business--------------
import PrivateRoutebusiness from './FrontEnd/Integration/PrivateRoutebusiness';

//----------- Supplier Permission -----------------
import DashboardHome from './FrontEnd/Main/DashboardHome'
import DashboardOrderProduto from './FrontEnd/Main/DashboardOrderProduto';
import DashboardSearchProduto from './FrontEnd/Main/DashboardSearchProduto';
import DashboardDeletProduct from './FrontEnd/Main/DashboardDeleteProduto';
import DashboardUpdateProduto from './FrontEnd/Main/DashboardUpdateProduto';
import DashboardAddProduto from './FrontEnd/Main/DashboardAddProduto';
import PageAddCompany from './FrontEnd/Main/PageAddCompany';
import LoginBusiness from './FrontEnd/Main/LoginBusiness';
import DashboardAddAdds from './FrontEnd/Main/DashboardAddAdds';
import PageSupplierFacturas from './FrontEnd/Main/PageSupplierFacturas';
import PageSupplierOrder from './FrontEnd/Main/PageSupplierOrder';
import PageSupplierProfile from './FrontEnd/Main/PageSupplierProfile';
import PageSupplierVendas from './FrontEnd/Main/PageSupplierVendas';
import PageSupplierUpdate from './FrontEnd/Main/PageSupplierUpdate';


function App() {
  return (

     <BrowserRouter>
      {/* Navigation */}
      <nav>
       
      </nav>

      {/* Routes */}
      <Routes>
    
        {/* Routes Para Fornecedores*/}
  
        <Route path="/Business/Login" element={<LoginBusiness/>} />
        <Route path="/Login" element={<LoginBusiness/>} />
        <Route path="/Register" element={<PageAddCompany/>} />
        <Route path="/MNGMT/Add/Produto"  element={<PrivateRoutebusiness> <DashboardAddProduto/> </PrivateRoutebusiness>  } />
        <Route path="/MNGMT/Update/Produto"  element={ <PrivateRoutebusiness>  <DashboardUpdateProduto/> </PrivateRoutebusiness>} />
        <Route path="/MNGMT/Del/Produto"  element={ < PrivateRoutebusiness>  <DashboardDeletProduct/> </PrivateRoutebusiness>} />
        <Route path="/MNGMT/Search/Produto"  element={ <PrivateRoutebusiness>  <DashboardSearchProduto/> </PrivateRoutebusiness>} />
        <Route path="/MNGMT/Order/Produto"  element={ <PrivateRoutebusiness>  <DashboardOrderProduto/> </PrivateRoutebusiness>} />
        <Route path="/MNGMT/Ads/Produto"  element={ < PrivateRoutebusiness>  <DashboardAddAdds/> </PrivateRoutebusiness>} />
        <Route path="/Home"  element={< PrivateRoutebusiness>  <DashboardHome/> </PrivateRoutebusiness> } />
        <Route path="/MNGMT/Business/Facturas" element={<PrivateRoutebusiness><PageSupplierFacturas/> </PrivateRoutebusiness>} />
        <Route path="/MNGMT/Business/Vendas" element={<PrivateRoutebusiness><PageSupplierVendas/> </PrivateRoutebusiness>} />
        <Route path="/MNGMT/Profile/*" element={<PrivateRoutebusiness><PageSupplierProfile/> </PrivateRoutebusiness>} />  
        <Route path="/MNGMT/Profile/Update/*" element={<PrivateRoutebusiness><PageSupplierUpdate/> </PrivateRoutebusiness>} />
        <Route path="/MNGMT/Order/Produto/2day"  element={ <PrivateRoutebusiness>  <PageSupplierOrder/> </PrivateRoutebusiness>} />
         <Route path="/" element={<LoginBusiness/>} />

        
          
        
        
       
      </Routes>
    </BrowserRouter>
  );
}

export default App;
